<button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="disabled"
        [ngClass]="{'titled-button': title && title.length}">
  <div class="action-menu-icon icomoon {{ icon }}" *ngIf="icon"></div>
  <span *ngIf="title">{{ title }}</span>
</button>

<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <ng-content></ng-content>
</mat-menu>
